
































































import Vue from "vue";
import axios from "axios";
import Player from "./Player.vue";
import FriendInfo from "./FriendInfo.vue";
import Tile from "./Tile.vue";
import Hand from "./Hand.vue";
import { GameStateResponse, IMove } from "../models/game_state";

export default Vue.extend({
  name: "Game",
  components: { Player, Tile, FriendInfo, Hand },
  props: {
    msg: String,
    gameID: String,
    playerNumber: Number,
  },
  data() {
    return {
      info: null, // GameStateResponse
      playerOptions: ["east", "south", "west", "north"],
      playerPos: ["right", "opposite", "leftplayer"],
      showWinningHand: false,
      lastShownWinningHand: -1
    };
  },
  computed: {
    prevailingWind(): string {
        return this.info ? this.playerOptions[this.info.game_state.prevailing_wind] :  "loading..."
    },
    remainingTileCount(): string {
      return this.info ? this.info.game_state.remaining_tiles.length :  "loading...";
    },
    playerWind(): string {
      if (!this.info) {
        return ".....loading"
      }
      const pos = this.info.game_state.starter - this.playerNumber;
      switch (pos) {
        case 0:
          return "east";
        case 2:
          return "west";
        case -2:
          return "west";
        case 1:
          return "north";
        case -3:
          return "north";
        case -1:
          return "south";
        case 3:
          return "south";
      }
      return "BUG. Pls screenshot and file an issue on github.com/slai11/mahjong"
    },
    winningTile(): number {
      // if the player wins on turn 1, there is no last discarded nor last drawn.
      // the player is a god of mahjong
      return this.info ? this.info.game_state.last_winning_hand.winning_tile : -1
    },
    turnNumber(): number {
      return this.info ? this.info.game_state.turn_number : null;
    },
    friendOrder(): number[] {
      switch (this.playerNumber) {
        case 0:
          return [1, 2, 3];
        case 1:
          return [2, 3, 0];
        case 2:
          return [3, 0, 1];
        case 3:
          return [0, 1, 2];
        default:
          return [];
      }
    }
  },
  mounted() {
    const fn = () => this.getGameState();
    fn();
    setInterval(function() {
      fn();
    }, 2000);
  },
  methods: {
    getGameState() {
      axios
        .get<GameStateResponse>(
          `${process.env.VUE_APP_BACKEND_URL}/game_state?game_id=${this.gameID}`
        )
        .then(response => {
          this.info = response.data
          // only update dialog status when its not true, else you will close the box while player is still viewing
          if (!this.showWinningHand) {
            this.showWinningHand = this.info.game_state.turn_number === this.info.game_state.last_winning_turn && this.info.game_state.turn_number !== this.lastShownWinningHand
            this.lastShownWinningHand = this.info.game_state.last_winning_turn
          }
        });
    },
    postMove(event: IMove) {
      event["turn_number"] = this.turnNumber;
      axios
        .post<GameStateResponse>(`${process.env.VUE_APP_BACKEND_URL}/move`, {
          "game_id": this.gameID,
          move: event
        })
        .then(response => {
          this.info = response.data;
        })
        .catch(error => {
          console.log(error);
          alert(`Move not allowed: ${error}`);
        });
    },
    postInterruptMove(event: IMove) {
      event["turn_number"] = this.turnNumber;
      event["tile"] = this.info.game_state.last_discarded_tile;
      console.log(event);
      axios
        .post<GameStateResponse>(`${process.env.VUE_APP_BACKEND_URL}/move`, {
          "game_id": this.gameID,
          move: event
        })
        .then(response => {
          this.info = response.data;
        })
        .catch(error => {
          console.log(error);
          alert(`Move not allowed: ${error}`);
        });
    }
  }
});
